export enum ArchiveType {
  fileArchive = 'צא״ח דרייב',
  waArchive = 'פרסומים להפצה',
  linksArchive = 'קישורים שימושיים',
  kedmaArchive = 'פרסומים לעיצוב',
  formsArchive = 'טפסים ושאלונים',
  eventsArchive = 'אירועים',
  archiveGallery = 'חב"ד בפריים',
  donationsArchive = 'תרומות',
  informationPagesArchive = 'דפי מידע'
}

export const PERSONAL_PAGE_ARCHIVE_TYPES = [
  ArchiveType.donationsArchive,
  ArchiveType.eventsArchive,
  ArchiveType.informationPagesArchive
] as const;

export type PersonalPageArchiveType = (typeof PERSONAL_PAGE_ARCHIVE_TYPES)[number];

export function isPersonalPageArchiveType(value?: string): value is PersonalPageArchiveType {
  return Boolean(value && (PERSONAL_PAGE_ARCHIVE_TYPES as readonly string[]).includes(value));
}
